/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import Button from 'components/base/Button';
import LoadingButton from 'components/custom/animate-component/LoadingButton';
import PageLoader from 'components/custom/animate-component/PageLoader';
import apiEndpoints from 'constants/apiEndpoints';
import { useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import fetchData from 'services/fetchData';
import * as Yup from 'yup';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    /* max-width: 300px !important; */
    margin-right: auto;
    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

const GetFlyAshChallanModal = ({
  show,
  showAlert,
  handleClose,
  setFocusedRow,
  // updateFetchChallan,
  handleRefresh
}) => {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleOnSubmit = async values => {
    setLoading(true);
    // const response = await fetchData(
    //   `fetch_flyash_challan?challan_no=${values.challan_no}`
    // );
    const response = await fetchData(
      apiEndpoints.challan.fetchFlyashChallan(values.challan_no)
    );
    if (response.status) {
      handleClose();
      // if (response.data.trans_status === 'Created') {
      // updateFetchChallan(response.data);
      handleRefresh();
      setFocusedRow(true);
      showAlert({
        variant: 'success',
        message: `FlyAsh is fetched: #${values.challan_no}.`
      });
      // } else {
      //   setFocusedRow(false);
      //   showAlert({
      //     variant: 'warning',
      //     message: `This FlyAsh #${values.challan_no}, payment has been initiated.`
      //   });
      // }
    } else {
      handleClose();
      showAlert({
        variant: 'danger',
        message: `Failed to fetch FlyAsh no. #${values.challan_no}: ${response.message}.`
      });
    }
  };

  const { handleSubmit, handleChange, handleBlur, values, touched, errors } =
    useFormik({
      initialValues: {
        challan_no: ''
      },
      validationSchema: Yup.object({
        challan_no: Yup.string().required('Please provide the challan number')
      }),

      onSubmit: values => {
        handleOnSubmit(values);
        // You can perform submission logic here
      },
      validateOnChange: false, // Disable validation on change
      validateOnBlur: false
    });

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <CustomModal
      //   size="md"
      //   dialogClassName="modal-300px"
      show={show}
      onHide={handleClose}
      backdrop="static"
      // style={{ overflow: 'hidden' }}
      keyboard={false}
    >
      <Modal.Header
        className="border-0 position-relative pb-0 end-0 dark__text-white"
        closeButton={!loading}
      >
        <div>
          <h4>Get Fly ash Challan</h4>
          <p className="fs-10 text-600">
            Get the challan if it is not shown in the pending payment list.
          </p>
        </div>
      </Modal.Header>

      <Modal.Body className="pt-3 pb-5 px-5 position-relative">
        <div>
          <div className="bg-100 p-2 border rounded-3">
            <p className="mb-1 fs-9">Enter Challan Number</p>
            <Form.Group className="position-relative" controlId="challan_no">
              <Form.Control
                size="sm"
                type="text"
                ref={inputRef}
                isInvalid={touched.challan_no && errors.challan_no}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.challan_no}
                onKeyDown={handleKeyDown}
              />
              <Form.Control.Feedback
                style={{ borderRadius: '0.25rem' }}
                type="invalid"
                tooltip
              >
                {errors.challan_no}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="phoenix-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="phoenix-success"
          primaryText={'Fetch'}
          loadingText={'Fetch...'}
          isLoading={loading}
          idClass="fetchChallan"
          onClick={handleSubmit}
        />
      </Modal.Footer>
      <PageLoader loading={loading} loadingMessage={'Fetching challan'} />
    </CustomModal>
  );
};

export default GetFlyAshChallanModal;
